"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteVariable = exports.SiteVariableJsonMapper = exports.SiteVariableDynamoMapper = void 0;
var site_variable_dynamodb_1 = require("./site-variable-dynamodb");
Object.defineProperty(exports, "SiteVariableDynamoMapper", { enumerable: true, get: function () { return site_variable_dynamodb_1.SiteVariableDynamoMapper; } });
var site_variable_json_1 = require("./site-variable-json");
Object.defineProperty(exports, "SiteVariableJsonMapper", { enumerable: true, get: function () { return site_variable_json_1.SiteVariableJsonMapper; } });
var site_variable_model_1 = require("./site-variable-model");
Object.defineProperty(exports, "SiteVariable", { enumerable: true, get: function () { return site_variable_model_1.SiteVariable; } });
